import React from "react";
import { useTranslation } from "react-i18next";

export default function InfoPopup({ show, status, title, message, onClose }) {
  const { t } = useTranslation();

  if (!show) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(15,23,42,0.4)",
        backdropFilter: "blur(4px)",
        zIndex: 1300,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px"
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 24px 80px rgba(102, 126, 234, 0.25)",
          minWidth: 320,
          maxWidth: "500px",
          width: "100%",
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden"
        }}
      >
        {/* Header with gradient */}
        <div style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          padding: "20px 24px",
          color: "#fff"
        }}>
          <div style={{
            fontWeight: 700,
            fontSize: 20,
            textAlign: "center"
          }}>
            {title}
          </div>
        </div>
        
        {/* Content */}
        <div style={{ 
          color: "#475569", 
          fontSize: 15,
          padding: "24px",
          overflowY: "auto",
          flex: 1,
          lineHeight: "1.6",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          textAlign: "left"
        }}>
          {message}
        </div>
        
        {/* Footer */}
        <div style={{
          padding: "16px 24px",
          borderTop: "1px solid #f1f5f9",
          display: "flex",
          justifyContent: "center"
        }}>
          <button
            onClick={onClose}
            style={{
              padding: "12px 32px",
              borderRadius: 8,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "#fff",
              border: "none",
              fontWeight: 600,
              fontSize: 15,
              cursor: "pointer",
              transition: "all 0.2s",
              boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)"
            }}
            onMouseOver={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 16px rgba(102, 126, 234, 0.4)";
            }}
            onMouseOut={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 12px rgba(102, 126, 234, 0.3)";
            }}
          >
            {t("InfoPopup.ok", "OK")}
          </button>
        </div>
      </div>
    </div>
  );
}